import { CollapsibleRuleGroup } from '@wix/rules-panel-ui';
import React from 'react';
import { useSiteLevelPageGroup } from './use-site-level-page-group';
export const SiteLevelPageGroup = /*#__PURE__*/React.memo(() => {
  const {
    siteLevelPageGroupProps
  } = useSiteLevelPageGroup();
  return /*#__PURE__*/React.createElement(CollapsibleRuleGroup, siteLevelPageGroupProps);
});
//# sourceMappingURL=site-level-page-group.js.map